export default {"src":"/_next/static/media/instagram-logo.2d2a6bdd.svg","height":25,"width":24};